// src/modules/app-views/ticket-events/pages/Init/components/tableColumns/nameColumn.js
import { Tooltip } from 'antd';
import translateX from 'utils/translateX';

const LINE_CLAMP_1 = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  overflow: 'hidden',
  wordBreak: 'break-all',
};

function nameColumn(buildColumnProps) {
  return {
    key: 'name',
    title: translateX('name'),
    dataIndex: 'name',
    width: 280,
    ...buildColumnProps('name', { sort: true, search: true }),
    render: (_, r) => (
      <Tooltip title={r?.name}>
        <span className="font-weight-semibold" style={LINE_CLAMP_1}>
          {r?.name || null}
        </span>
      </Tooltip>
    ),
  };
}

export default nameColumn;
